import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SaveIcon from '@material-ui/icons/SaveAlt';
import Linkify from 'linkifyjs/react';
import ContactAvatar from '../../../../../components/ContactAvatar';
import moment from 'moment';
import {FileMapper} from '../../../../../utils/FileService';
import config from '../../../../../config';
import {convertFormBackendDate, MessageType, myDarkBlue} from '../../../../../utils/General';
import CommentMessage from '../../../../../assets/images/lock.png';
import LockedMessage from "../../../../../components-new/LockedMessage";
import ContextMenu from "../../../../../components-new/ContextMenu";
import Translate from "../../../../../components/Translate";
import {addCustomTemplate} from "../../../../../services/company/api";
import {addNotification as addNotificationAction} from "../../../../../services/notification/action";
import {connect} from "react-redux";
import CopyIcon from '../../../../../assets/images/copy.png';
import ReadIcon from '../../../../../assets/images/read.svg';
import UnreadIcon from '../../../../../assets/images/unread.svg';
import DeleteIcon from '../../../../../assets/images/delete.png';
import EditIcon from '../../../../../assets/images/edit-white.png';
import EditBlueIcon from '../../../../../assets/images/edit-blue.png';
import CheckIcon from '../../../../../assets/images/check.png';
import CloseIcon from '../../../../../assets/images/close.png';
import AddTemplateIcon from '../../../../../assets/images/add-template.png';
import {deleteMessage, editMessage} from "../../../../../services/chat/api";
import Input from "../../../../../components-new/Input";
import Reply from '../../../../../assets/images/reply.png';
import ReplyWhite from '../../../../../assets/images/reply-white.png';

class Message extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showContextMenu: false,
            contextMenuPosition: {x: 0, y: 0},
            isDeleted: false,
            isEdited: false,
            isEditing: false,
            editedMessageText: props.message.text
        };
        this.editInputRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isEditing && this.state.isEditing && this.editInputRef.current) {
            const input = this.editInputRef.current;
            input.focus();

            const length = input.value.length;
            input.setSelectionRange(length, length);
        }
    }

    handleContextMenu = (event) => {
        event.preventDefault();
        this.setState({
            showContextMenu: true,
            contextMenuPosition: {x: event.clientX, y: event.clientY}
        });
    };

    handleEditChange = (e) => {
        this.setState({editedMessageText: e.target.value});
    };

    handleEditSubmit = () => {
        const {editedMessageText} = this.state;
        const {message, addNotification} = this.props;

        editMessage(message.id, editedMessageText)
            .then(() => {
                message.text = editedMessageText;
                message.edited = true;
                this.setState({
                    isEditing: false,
                    isEdited: true
                });
                addNotification('messageEdited', config.notificationLevels.info);
            })
            .catch((error) => {
                if (error.response && error.response.status === 423) {
                    addNotification('actionBlockedByAdmin', config.notificationLevels.warning);
                } else if (error.response && error.response.status === 409) {
                    addNotification('notYourMessage', config.notificationLevels.warning);
                } else if (error.response && error.response.status === 412) {
                    addNotification('editLimitError', config.notificationLevels.warning);
                } else {
                    addNotification('somethingWentWrong', config.notificationLevels.error);
                }
            });
    };

    static isUserReceiver(message, user) {
        try {
            const {to, from} = message;
            if (user) {
                if (to.platformId === user.id) {
                    return true;
                }
            }
            return (from.platform !== config.platformsMap.company && !from.bot);
        } catch (e) {
            return false;
        }
    }

    static getMessageContent(message, openImageViewer, isDeleted = false) {
        if (isDeleted) {
            return (
                <p style={{fontStyle: 'italic', color: '#9e9e9e'}}>
                    <Translate text="messageDeleted"/>
                </p>
            );
        }

        if (message.endMessage) {
            const endedBy = message.endBy === 'user' ? (
                <Translate text="chatEndedByUser"/>
            ) : (
                <React.Fragment>
                    <Translate text="chatEndedByOperator"/> ({message.endBy})
                </React.Fragment>
            );

            return (
                <div style={{
                    textAlign: 'center',
                    margin: '20px 0',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    backgroundColor: '#f0f0f0',
                    color: '#555',
                    fontSize: '11px'
                }}>
                    {endedBy} (
                    {new Date(message.date).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                    })}
                    )

                </div>
            );
        }

        if (message.forwardMessage) {
            const forwardedBy = message.forwardedBy
            const forwardedTo = message.forwardedTo

            return (
                <div style={{
                    textAlign: 'center',
                    margin: '20px 0',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    backgroundColor: '#f0f0f0',
                    color: '#555',
                    fontSize: '11px'
                }}>
                    <Translate text={'chatForwarded'}/> ({forwardedBy} → {forwardedTo})

                    (
                    {new Date(message.date).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                    })}
                    )
                </div>
            );
        }

        const notSentWarning = message.notSent ? (
            <div style={{marginTop: '5px'}}>
                <p style={{fontStyle: 'italic', color: 'rgb(251,151,151)', fontSize: '12px'}}>
                    <Translate text="messageIsNotSent"/>
                </p>
            </div>
        ) : null;

        const messageType = message.type;
        let content;

        switch (messageType) {
            case MessageType.aiText:
            case MessageType.quickReply:
            case MessageType.text:
                content = (
                    <Linkify tagName="span">
                        {message.draftMessage && !message.commentMessage ? ( // draft message
                            <div className="message-draft-wrapper animate-slide-in">
                                <div style={{margin: 0}} className="typing-indicator">
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </div>
                                {message.text}
                            </div>
                        ) : message.commentMessage && !message.notSent ? ( // comment message
                            <div className="animate-slide-in">
                                <LockedMessage
                                    message={message}
                                    Unsent={CommentMessage}
                                    tooltip={'commentMessageTooltip'}
                                    messageColor={'#043e5c'}
                                    iconHeight={20}
                                    iconWidth={20}
                                />
                            </div>
                        ) : (
                            <span className="message-text animate-fade-in" style={{whiteSpace: 'pre-wrap'}}>
                                {message.text}
                            </span>
                        )}
                    </Linkify>
                );
                break;
            case FileMapper.image:
                content = (
                    <button
                        type="button"
                        style={{display: 'block', border: 'none', background: 'transparent'}}
                        onClick={() => openImageViewer(message.attachment)}
                    >
                        {message.attachment && message.attachment.url && (
                            <img
                                src={message.attachment.url}
                                style={{height: '200px', width: 'auto', maxWidth: '100%'}}
                            />
                        )}
                    </button>
                );
                break;
            case FileMapper.video:
                content = (
                    <video style={{width: '200px', height: '200px'}} controls>
                        {message.attachment && message.attachment.url && (
                            <source src={message.attachment.url}/>
                        )}
                    </video>
                );
                break;
            case FileMapper.audio:
                content = (
                    <audio controls style={{width: '300px'}}>
                        {message.attachment && message.attachment.url && (
                            <source src={message.attachment.url}/>
                        )}
                    </audio>
                );
                break;
            case FileMapper.application:
                content = (
                    <a
                        className="link"
                        href={message.attachment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{display: 'flex', alignItems: 'center'}}
                    >
                        <SaveIcon color="primary"/>
                        <p style={{color: '#84c133', marginLeft: '5px'}}>
                            {message.attachment.name}
                        </p>
                    </a>
                )
                break;
            default:
                content = <p style={{color: 'white'}}>Message</p>;
        }

        return (
            <div>
                {content}
                {notSentWarning}
            </div>
        );
    }

    handleAction = (action) => {
        const {message, addNotification, updateTemplates, setReplyTo} = this.props;
        if (action === 'copy') {
            navigator.clipboard.writeText(message.text)
                .then(() => {
                    addNotification('copied', config.notificationLevels.info);
                })
                .catch(() => {
                    addNotification('somethingWentWrong', config.notificationLevels.error);
                })
        } else if (action === 'addTemplate') {
            addCustomTemplate(message.text)
                .then((r) => {
                    updateTemplates(r)
                    addNotification('added', config.notificationLevels.success);
                })
                .catch(() => {
                    addNotification('somethingWentWrong', config.notificationLevels.error);
                })
        } else if (action === 'delete') {
            deleteMessage(message.id)
                .then(() => {
                    this.setState({isDeleted: true});
                    addNotification('messageDeleted', config.notificationLevels.info);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 423) {
                        addNotification('actionBlockedByAdmin', config.notificationLevels.warning);
                    } else if (error.response && error.response.status === 409) {
                        addNotification('notYourMessage', config.notificationLevels.warning);
                    } else {
                        addNotification('somethingWentWrong', config.notificationLevels.error);
                    }
                })
        } else if (action === 'edit') {
            this.setState({isEditing: true});
        } else if (action === 'reply') {
            setReplyTo(message);
            this.props.childRef.current.focusTextareaToEnd(); // MessageInput ref
        }

        this.setState({showContextMenu: false});
    };

    renderContextMenu() {
        const {showContextMenu, contextMenuPosition} = this.state;
        const {message, user, conversation, company} = this.props;

        let features = [];
        if (company && company.tariff) {
            features = company.tariff.features
        }

        if (!showContextMenu) return null;

        const isMediaType = ['FILE', 'VIDEO', 'PHOTO', 'AUDIO'].includes(message.type);
        const isUserSender = !Message.isUserReceiver(message, user);

        const items = [];

        if (!isMediaType) {
            items.push({
                key: 'copy',
                icon: CopyIcon,
                label: <Translate text="copy"/>,
                onClick: () => this.handleAction('copy'),
            });

            if (isUserSender && features.includes(config.features.TEMPLATES)) {
                items.push({
                    key: 'addTemplate',
                    icon: AddTemplateIcon,
                    label: <Translate text="addTemplate"/>,
                    onClick: () => this.handleAction('addTemplate'),
                });
            }
        }

        if (!isMediaType
            && isUserSender
            && conversation.platform === config.platformsMap.webchat
            && message.chatWithOperator
            && features.includes(config.features.MESSAGE_EDIT)
        ) {
            items.push({
                key: 'edit',
                icon: EditIcon,
                label: <Translate text="edit"/>,
                onClick: () => this.handleAction('edit'),
            });
        }

        if (isUserSender
            && conversation.platform === config.platformsMap.webchat
            && message.chatWithOperator
            && features.includes(config.features.MESSAGE_DELETE)
        ) {
            items.push({
                key: 'delete',
                icon: DeleteIcon,
                label: <Translate text="delete"/>,
                onClick: () => this.handleAction('delete'),
            });
        }

        if (features.includes(config.features.MESSAGE_REPLY)
            && conversation.platform === config.platformsMap.webchat
            && (message.draftMessage === false || message.draftMessage === undefined)
            && (message.commentMessage === false || message.commentMessage === undefined)
            && (message.text !== 'Start' && message.text !== 'end')
        ) {
            items.push({
                key: 'reply',
                icon: ReplyWhite,
                label: <Translate text="reply"/>,
                onClick: () => this.handleAction('reply'),
            });
        }

        if (items.length === 0) return null;

        return (
            <ContextMenu
                position={contextMenuPosition}
                items={items}
                onClose={() => this.setState({showContextMenu: false})}
            />
        );
    }

    renderReplyPreview(parentMessage) {
        if (!parentMessage) return null;

        const isMedia = ['FILE', 'VIDEO', 'PHOTO', 'AUDIO'].includes(parentMessage.type);

        const handleClick = () => {
            const element = document.getElementById(`message-${parentMessage.id}`);
            if (element) {
                element.scrollIntoView({behavior: 'smooth', block: 'center'});
                const el = document.getElementById(`message-3-div-${parentMessage.id}`);
                el.classList.add('highlight');
                setTimeout(() => {
                    element.classList.remove('highlight');
                }, 2000);
            }
        };

        return (
            <div
                className="reply-preview"
                onClick={handleClick}
                style={{cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px'}}
            >
                <div style={{userSelect: 'none', marginTop: '5px'}}>️
                    <img src={Reply} width={13} height={13}/>
                </div>
                <div className="reply-content">
                    <div
                        className="reply-text"
                        style={{
                            color: isMedia ? myDarkBlue : undefined,
                            fontStyle: isMedia ? 'italic' : 'normal',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '200px',
                        }}
                    >
                        {isMedia ? (
                            <Translate text="attachment"/>
                        ) : (
                            parentMessage.text || ''
                        )}
                    </div>
                </div>
            </div>
        );

    }

    render() {
        const {
            message,
            openImageViewer,
            displayTimeLine,
            user,
            highlight,
            reversedMessages,
            lastSeenMessageId
        } = this.props;
        const {isDeleted} = this.state;

        let contact;
        if (message.fromSupervisor && message.supervisor) {
            contact = message.supervisor
        } else {
            contact = message.from
        }

        const parentMessage = message.parent

        const type = Message.isUserReceiver(message, user) ? 'received' : 'sent';
        const messageTime = convertFormBackendDate(message.date);

        if (message.id === lastSeenMessageId) {
            message.seenByUser = true
        }

        const isUserSender = !Message.isUserReceiver(message, user);

        return (
            <div>
                {displayTimeLine && (
                    <div className="timeline-wrapper">
                        <div className="timeline-info-parent">
                            <div className="timeline-info">
                                {moment(messageTime).format('MMMM D')}
                            </div>
                        </div>
                    </div>
                )}

                {(message.endMessage || message.forwardMessage) && (
                    <div style={{marginBottom: '20px'}}>
                        {Message.getMessageContent(message, openImageViewer, isDeleted)}
                    </div>
                )}

                {(!message.endMessage && !message.forwardMessage) && (
                    <div className={`message ${type}`} key={message.id} id={`message-${message.id}`}>
                        <div className="avatar-wrapper" style={{marginTop: '32px'}}>
                            <ContactAvatar contact={contact} inChat={true}/>
                        </div>
                        <div>
                            <div
                                id={`message-3-div-${message.id}`}
                                onContextMenu={this.handleContextMenu}
                                className={`message-content 
                                ${highlight ? 'highlight' : ''} 
                                ${this.state.isDeleted ? 'deleted' : ''} 
                                ${message.fromSupervisor ? 'supervisor-message' : ''}`
                                }
                                style={{marginBottom: '20px', transition: 'all 0.3s'}}
                            >
                                <div style={{padding: '3px 10px'}}>
                                    {parentMessage && this.renderReplyPreview(parentMessage)}

                                    {this.state.isEditing && (
                                        <div className="edit-message-wrapper"
                                             style={{display: 'flex', gap: '16px', alignItems: 'center'}}>
                                            <Input
                                                isTextarea={true}
                                                value={this.state.editedMessageText}
                                                onChange={this.handleEditChange}
                                                rows={3}
                                                style={{width: '100%', resize: 'vertical'}}
                                                ref={this.editInputRef}
                                            />
                                            <span onClick={() => {
                                                this.setState({isEditing: false, editedMessageText: message.text});
                                            }}
                                                  style={{cursor: 'pointer'}}>
                                            <img src={CloseIcon} width={16} height={16}/>
                                        </span>
                                            <span onClick={this.handleEditSubmit} style={{cursor: 'pointer'}}>
                                             <img src={CheckIcon} width={20} height={20}/>
                                        </span>
                                        </div>
                                    )}

                                    {!this.state.isEditing && (
                                        Message.getMessageContent(message, openImageViewer, isDeleted)
                                    )}

                                </div>
                            </div>
                            <div>
                                <div className="message-time"
                                     style={{display: 'flex', alignItems: 'center', gap: '8px'}}>

                                    <div className="message-indicator-div">
                                        {moment(messageTime).format('HH:mm')}
                                    </div>

                                    {(message.seenByUser && isUserSender) && (
                                        <div className="message-indicator-div">
                                            <img width={15} height={15} src={ReadIcon}/>
                                        </div>
                                    )}

                                    {(!message.seenByUser && isUserSender) && (
                                        <div className="message-indicator-div">
                                            <img width={15} height={15} src={UnreadIcon}/>
                                        </div>
                                    )}

                                    {message.edited && (
                                        <div className="message-indicator-div">
                                            <img width={13} height={13} src={EditBlueIcon}/>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.renderContextMenu()}

            </div>
        );
    }
}

const mapDispatchToProps = {
    addNotification: addNotificationAction,
};

Message.propTypes = {
    message: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    openImageViewer: PropTypes.func.isRequired,
    displayTimeLine: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    lastSeenMessageId: state.chat.lastSeenMessageId,
});

export default connect(mapStateToProps, mapDispatchToProps)(Message);




// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/Message.jsx